<template minapp='mpx' xlang='wxml'>
  <view class="card" wx:class="{{{first: cardIndex === 1,last: cardIndex === 2}}}">
    <view class="card-left">
      <view class="card-addr">
        <view class="start-addr">{{ flattenTicketInfos.from_station_name }}</view>
        <es-icon name="arrow-switch-right" color="#666666" class="icon" />
        <view class="end-addr">{{ flattenTicketInfos.to_station_name }}</view>
        <view>{{ flattenTicketInfos.train_code }}</view>
        <view class="icon-arr" wx:for="{{iconArr}}" wx:key="index" wx:for-item="iconItem">
          <image
            wx:if="{{flattenTicketInfos[iconItem[0]]===1||flattenTicketInfos[iconItem[0]]===2}}"
            src="{{iconItem[1]}}"
            class="icon-img"
          />
        </view>
      </view>
      <view class="card-time card-inform"> {{ tickets12306 ? item.start_time_format : flattenTicketInfos.start_time }}出发 </view>
      <view class="passenger_info" wx:if="{{flattenTicketInfos.passenger_info}}"> 乘客信息: {{ flattenTicketInfos.passenger_info }} </view>
    </view>
    <view class="card-right" wx:if="{{!flattenTicketInfos.union_journey}}">
      <wxs src="../lib/pub.wxs" module="pub" />
      <hl-text
        class="card-status"
        text="{{ flattenTicketInfos.status_name || pub.getTrainStatusValue(flattenTicketInfos)}}"
        color="{{flattenTicketInfos.status_color}}"
        hlColor="{{flattenTicketInfos.status_color}}"
      />
      <view wx:if="{{flattenTicketInfos.order_number && ispre}}" class="order-num">
        订单号：{{ item.order_number }}
      </view>
    </view>
  </view>
</template>

<script>
import { createComponent, mpx } from '@didi/es-mpx-creator'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

createComponent({
  props: {
    item: {
      type: Object,
      value: {}
    },
    cardIndex: {
      type: Number,
      value: 0
    },
    tickets12306: {
      type: Boolean,
      value: false
    }
  },
  data: {
    iconArr: {
      booking_type: [
        'booking_type',
        'https://pt-starimg.didistatic.com/static/starimg/img/bP3eDLKt6x1646796322957.png'
      ],
      is_over: [
        'is_over',
        'https://pt-starimg.didistatic.com/static/starimg/img/7NYCKORsor1645615876559.png'
      ],
      is_change: [
        'is_change',
        'https://img-hxy021.didistatic.com/static/starimg/img/KrQgA8xP9e1676430350757.png'
      ]
    }
  },
  computed: {
    ispre() {
      return (
        (__mpx_mode__ == 'web' &&
          (window.location?.href?.indexOf('pre-release-') > -1 ||
            window.location?.href?.indexOf('8082') > -1)) ||
        window.location?.href?.indexOf('10.190.55.97') > -1 ||
        window.location?.href?.indexOf('pre-railway') > -1
      )
    },
    flattenTicketInfos() {
      if (!this.item?.ticket_infos || !Array.isArray(this.item?.ticket_infos)) {
        return this.item
      }
      const { ticket_infos, ...rest } = this.item
      const newItem = { ...rest, ...ticket_infos[0] }
      if (newItem.start_time && Number.isInteger(newItem.start_time)) {
        const time = newItem.start_time * 1000
        newItem.start_time = dayjs(time).format('M月D日 周dd HH:mm')
      }
      return newItem
    }
  },
  methods: {}
})
</script>

<style scoped lang="stylus">
.card
  display flex
  position relative
  justify-content space-between
  background-color #ffffff
  border-radius 8px
  padding 16px
  font-family PingFangSC-Regular
  &.first
    border-radius 8px 8px 0 0
    &::after
      position absolute
      content ''
      width 184%
      height 1px
      transform translateX(-50%) scale(0.5)
      bottom 0
      left 50%
      background-color #eee
  &.last 
    border-radius 0 0 8px 8px
.card-addr
  color #333
  display flex
  height 20px
  justify-content flex-start
  align-items center
  font-size 16px
  font-family PingFangSC-Medium
  font-weight 500
.card-inform
  font-size 12px
  height 16px
  line-height 16px
  font-weight 400
  color #666666
.card-time
  font-size 14px
  height 20px
  line-height 20px
  margin 8px 0 4px 0
  color #333333
  font-family PingFangSC-Medium
  font-weight 500
.card-right
  color #999999
  font-size 14px
display flex, flex-direction column, justify-content space-between, .end-addr
  margin-right 10px
.icon
  margin 4px 4px 0
  font-weight 100
  font-size 14px
.card-status
  font-size 14px
  position absolute
  right 16px
  top 16px
  font-family PingFangSC-Medium
.orange
  color #FF7F41
.blue
  color #1473FF
.gray
  color #999999
.icon-arr
  display flex
  align-items center
.icon-img
  width 24px
  height 14px
  margin-left 4px
.passenger_info
  font-size 13px
  color #666666
  height 18px
  line-height 18px
.order-num
  position absolute
  right 16px
  bottom 16px
  font-size 13px
  color #666666
  height 18px
  line-height 18px
</style>
<script name='json'>
module.exports = {
  component: true,
  usingComponents: {
    'es-icon': '@didi/es-mpx-ui/lib/icon/index',
    'hl-text': '@/components/hl-text'
  }
}
</script>
